import React from 'react';
import Select from 'react-select';
import s from './MultiselectDropdown.module.scss';

class MultiselectDropdown extends React.Component {
  //Constructor
  constructor(props) {
    super(props);
    this.state = {
      dataArray: [],
      selectedOptions: []
    };
  }

  //componentDidMount
  componentDidMount() {
    const { dataArray = [], selectedOptions = [], componentDidMount } = this.props;
    
    this.setState({ 
      dataArray, 
      selectedOptions 
    });

    if (componentDidMount) {
      componentDidMount();
    }
  }

  //componentDidUpdate(prevProps, prevState, snapshot)
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.componentDidUpdate) {
      this.props.componentDidUpdate(prevProps, prevState, snapshot);
    }
  }

  //Component will unmount
  componentWillUnmount() {
    if (this.props.componentWillUnmount) {
      this.props.componentWillUnmount();
    }
  }

  //componentDidCatch(error, info)
  componentDidCatch(error, info) {
    if (this.props.componentDidCatch) {
      this.props.componentDidCatch(error, info);
    }
  }

  //render method
  render() {
    const { 
      selectedOptions = [], 
      handleChange, 
      sensorOptions 
    } = this.props;
    
    return (
      <Select
        className={s.multiSelect}
        // classNamePrefix="multi"
        IndicatorsContainer={false}
        value={selectedOptions}
        isClearable={false}
        isMulti
        onChange={handleChange}
        options={sensorOptions}
      />
    );
  }
}

export default MultiselectDropdown;